import React, { useState, useEffect } from "react";
import { UserIcon, ShoppingBagIcon } from "@heroicons/react/solid";
import { CurrencyRupeeIcon } from "@heroicons/react/outline";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import ManageAddress from "../../components/profile/ManageAddress";
import PersonalInfo from "../../components/profile/PersonalInfo";
import Orders from "../../components/profile/Orders";
import useAuth from "../../config/AuthContext";
import { useToken } from "../../config/useToken";
import { useParams, useNavigate } from "react-router-dom";
import Wishlist from "../../components/profile/Wishlist";

const Profile = () => {
  const { section } = useParams();
  const { getUser, wallet } = useToken();
  const { logout } = useAuth();
  const [component, setComponent] = useState(section || "personal");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [balance, setBalance] = React.useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    setUser(getUser());
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getWallet = async () => {
      var res = await wallet();
      setBalance(res.balance ?? 0);
    };
    getWallet();
    setComponent(section || "personal")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  const handleComponent = () => {
    switch (component) {
      case "personal":
        return <PersonalInfo user={user} />;
      case "address":
        return <ManageAddress addressesData={user.address} />;
      case "orders":
        return <Orders />;
      case "wishlist":
        return <Wishlist />;
      default:
        return <PersonalInfo user={user} />;
    }
  };

  if (loading) {
    return null;
  }

  return (
    <>
      <Header />
      <div
        id="profile-page"
        className="flex gap-4 my-16 min-h-screen w-screen px-28"
      >
        <div className="flex flex-1 flex-col gap-y-4 h-full w-full">
          <div className="flex gap-4 p-3 bg-white shadow-md border rounded">
            <div className="w-12 h-12 rounded-full border bg-weHandCraftPrimary flex justify-center items-center">
              <span className="text-white font-medium text-xl">
                {user.first_name.charAt(0).toUpperCase()}
              </span>
            </div>
            <div className="flex-col">
              <div className="text-weHandCraftBlue text-xl font-medium capitalize">
                {user.first_name} {user.last_name}
              </div>
              <div className="text-weHandCraftBlue text-sm font-medium">
                {user.email}
              </div>

              {/* LOGOUT BTN */}
              <button
                className="bg-weHandCraftPrimary text-white text-sm font-medium py-2 px-4 rounded w-full mt-4"
                onClick={() => logout()}
              >
                Logout
              </button>
            </div>
          </div>
          <div className="flex-1 h-full gap-4 bg-white shadow-md border rounded">
            <div className="flex flex-col w-full p-4 border-b">
              <div className="flex gap-5 items-center mb-4">
                <UserIcon className="w-6 h-6 text-blue-600" />
                <p className="text-gray-500 font-semibold">ACCOUNT SETTINGS</p>
              </div>
              <div
                className="flex gap-5 items-center py-2 cursor-pointer"
                onClick={() => navigate("/profile")}
                style={component === "personal" ? { color: "#1c40dd" } : {}}
              >
                <div className="w-6 h-6" />
                <p className="text-sm">Personal Information</p>
              </div>
              <div
                className="flex gap-5 items-center py-2 cursor-pointer"
                onClick={() => navigate("/profile/address")}
                style={component === "address" ? { color: "#1c40dd" } : {}}
              >
                <div className="w-6 h-6" />
                <p className="text-sm">Manage Addresses</p>
              </div>
              {/* Show Balance */}
              <div className="flex gap-5 items-center my-4">
                <CurrencyRupeeIcon className="w-6 h-6 text-blue-600" />
                <h1 style={{ fontSize: "14px" }} className="text-base m-0">
                  Wallet Balance &nbsp;
                  {balance.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                    style: "currency",
                    currency: "INR",
                  })}
                </h1>
              </div>
            </div>
            <div className="flex flex-col w-full p-4 border-b">
              <div className="flex gap-5 items-center mb-4">
                <ShoppingBagIcon className="w-6 h-6 text-blue-600" />
                <p className="text-gray-500 font-semibold">ORDERS</p>
              </div>
              <div
                className="flex gap-5 items-center py-2 cursor-pointer"
                onClick={() => navigate("/profile/orders")}
                style={component === "orders" ? { color: "#1c40dd" } : {}}
              >
                <div className="w-6 h-6" />
                <p className="text-sm">My Orders</p>
              </div>
            </div>
            <div className="flex flex-col w-full p-4 border-b">
              <div className="flex gap-5 items-center mb-4">
                <ShoppingBagIcon className="w-6 h-6 text-blue-600" />
                <p className="text-gray-500 font-semibold">MY STUFF</p>
              </div>
              <div
                className="flex gap-5 items-center py-2 cursor-pointer"
                onClick={() => navigate("/profile/wishlist")}
                style={component === "wishlist" ? { color: "#1c40dd" } : {}}
              >
                <div className="w-6 h-6" />
                <p className="text-sm">My Wishlist</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-3 w-full bg-white shadow-md border rounded">
          {handleComponent()}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Profile;
